/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/Palm_low.glb -o src/models/plants/PalmLow.jsx --transform --draco 
Files: public/Palm_low.glb [7.03MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/plants/assets/plants/Palm_low-transformed.glb [359.3KB] (95%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../../assets/plants/Palm_low-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <group position={[-0.018, -0.018, 0]} rotation={[Math.PI / 2, 0, 0.526]} scale={0.01}>
        <mesh geometry={nodes.BezierCurve054.geometry} material={materials.PalmTrunk} />
        <mesh geometry={nodes.BezierCurve054_1.geometry} material={materials.PalmLeaves} />
      </group>
    </group>
  )
}

useGLTF.preload(modelUrl)
